import React, { useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { createDefaultPageData } from '../../../../types/rest/IPageData';
import { useGetSelfAdminUserQuery, useListPagedAdminUsersQuery } from '../../../../API/administration/AdminUsersAPI';
import { eAdminAccountStatus } from '../../../../types/administration/userAdministration/IAdminUser';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';
import { UUID } from '../../../../types/shared/UUID';

const useListSortedAdminUsers = () => {
  const { data: self } = useGetSelfAdminUserQuery();
  const { data: adminUsers = createDefaultPageData() } = useListPagedAdminUsersQuery({
    fetchAll: true,
    status: eAdminAccountStatus.Active,
  });
  return useMemo(() => {
    return adminUsers.content
      .toSorted((userA, userB) => {
        if (userA.id === self?.id) {
          return -1;
        }
        if (userB.id === self?.id) {
          return 1;
        }
        return userA.fullName.localeCompare(userB.fullName);
      })
      .map((user) => ({ label: user.fullName, value: user.id }));
  }, [adminUsers, self]);
};

export const InternalContactsFilter: React.FC = () => {
  const [field, meta, helpers] = useField<UUID[]>({ name: 'internalContacts' });
  const sortedAdminUsers = useListSortedAdminUsers();

  const onChange = useCallback(
    (nextValue: any) => {
      helpers.setValue(nextValue);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Assigned To</Label>}
      control={
        <Combobox
          value={field.value}
          options={sortedAdminUsers}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          multiple
          limitTagsShown={3}
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
